import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast } from 'antd-mobile';
import queryString from 'query-string';
import Http from '../../config/axiosUtils';

import '../../assets/scss/Notice/noticeDetail.scss';
import SystemIcon from '../../assets/images/notice/admin_small@2x.png';
import TipIcon from '../../assets/images/notice/tip_small@2x.png';

class NoticeDetail extends Component {
  state = {
    initData: {}
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { type } = queryString.parse(this.props.location.search);
    const id = this.props.match.params.id;
    let path = '';
    switch (type) {
      case '0': 
        path = `/spread/web/message/notice/${id}`;
        break;
      case '1': 
        path = `/spread/web/message/user/message/${id}`;
        break;
      default: 
        break;
    }
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        initData: res.data,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  render () {
    const { initData } = this.state;
    return (
      <div>
        <Helmet><title>消息详情</title></Helmet>
        <div className='noticeDetail'>
          <div className='date'>{initData.time}</div>
          <div className='text'>
            <div className='text-top'>
              <img src={initData.type === 0 ? SystemIcon : TipIcon} alt="" />
              <span>{initData.title}</span>
              {initData.isRead === 0 && <i></i>}
            </div>
            <div className='text-con'>{initData.content}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default NoticeDetail;